import { PersonArtistType } from '@api';
import { LinkableEntityType as ApiArtistType } from 'src/api/generated/touring/types';
import { mapLinkableEntityType } from '../../../../../common';

export const mapArtists = (artists: ApiArtistType[]): PersonArtistType[] => {
  return artists.map((artist) => mapLinkableEntityType(artist));
};
